// extracted by mini-css-extract-plugin
module.exports = {"codeInput":"codeInput_codeInput__2lYo3","error":"codeInput_error__22XLO","loadingCodeInput":"codeInput_loadingCodeInput__10dTq","errorText":"codeInput_errorText__1Vo2i"};